import flocknoteStateHooks from "Flocknote/stateHooks";

import { useFamilyRegistrationContext } from "Signups/FamilyRegistration/FamilyRegistrationContext";

const useFamRegIsLive = () => {
  const {
    state: { familyRegistrationIsLive },
  } = useFamilyRegistrationContext();

  return familyRegistrationIsLive;
};

export default function useFamilyRegistrationAdminPermissions() {
  const familyRegistrationIsLive = useFamRegIsLive();
  const {
    state: {
      userIsSuperAdmin,
      networkHasFamilyRegistration,
      networkHasFundIt,
      networkHasMembershipStatus,
      canEditMembershipStatusOptions,
      familyRegistrationSettings,
      networkCanHaveFundIt,
    },
  } = useFamilyRegistrationContext();

  const hasAvailableFunds =
    familyRegistrationSettings?.recurringGifts?.availableFunds?.length;
  const familyRegistrationSettingIsEnabled =
    familyRegistrationSettings?.networkFamilyRegistration?.enabled;

  // Some of these are slightly redundant, but doing it this way so that individual checks can be easily edited in the future...
  // ...without having to change the checks in the actual components
  const shouldShowAdminPanelView =
    userIsSuperAdmin &&
    (familyRegistrationIsLive || canEditMembershipStatusOptions);
  const shouldShowFamilyRegistrationBlurb =
    networkHasFamilyRegistration && !familyRegistrationSettingIsEnabled;
  const shouldHideNonNetworkEnabledSettings =
    !familyRegistrationSettingIsEnabled;
  const shouldSeparateMembershipStatusSection =
    !familyRegistrationIsLive ||
    ((!networkHasFamilyRegistration || !familyRegistrationSettingIsEnabled) &&
      networkHasMembershipStatus);
  const shouldDisableStatusCheckboxes = !canEditMembershipStatusOptions;
  const shouldDisableFamilyRegistrationSettings =
    familyRegistrationIsLive && !networkHasFamilyRegistration;
  const shouldEnableMembershipStatusSection =
    canEditMembershipStatusOptions && !shouldDisableFamilyRegistrationSettings;
  const shouldShowFNPMarketingBlurb = shouldDisableFamilyRegistrationSettings;
  const shouldDisableRecurringGifts =
    !shouldDisableFamilyRegistrationSettings &&
    (!networkHasFundIt || !hasAvailableFunds);
  const shouldHideFundItItems = !networkCanHaveFundIt;
  const shouldShowFundItBlurb =
    shouldDisableRecurringGifts && !networkHasFundIt && networkCanHaveFundIt;
  const shouldShowRecurringGiftsNoticeMessage =
    shouldDisableRecurringGifts && networkHasFundIt && !hasAvailableFunds;

  return {
    shouldShowAdminPanelView,
    shouldSeparateMembershipStatusSection,
    shouldEnableMembershipStatusSection,
    shouldDisableStatusCheckboxes,
    shouldDisableFamilyRegistrationSettings,
    shouldShowFNPMarketingBlurb,
    shouldDisableRecurringGifts,
    shouldShowFundItBlurb,
    shouldShowRecurringGiftsNoticeMessage,
    shouldShowFamilyRegistrationBlurb,
    shouldHideNonNetworkEnabledSettings,
    shouldHideFundItItems,
  };
}

const useShouldHideFamRegSettings = () => {
  const famRegIsLive = useFamRegIsLive();
  const isClosedNetwork = flocknoteStateHooks.useIsClosedNetwork();

  return !famRegIsLive || isClosedNetwork;
};

export { useShouldHideFamRegSettings };
